export const ENTITY_UNITS = {
  GRAM: 'g',
  KILOGRAM: 'kg',
  MILLILITER: 'mL',
  LITER: 'L',
  UNIT: 'unit',
};
